import React, {useMemo} from 'react';
import SourcePackage from "../../../../components/sourcePackage/SourcePackage";
import AIAssistant from "./AIAssistant";
import IcrSection from "../components/IcrSection";
import {useEditorLeftPanelTabs, useLeftPanelSync} from '../../hooks';
import LeftPanelTabs from '../../components/common/LeftPanelTabs';
import SourcesSection from './components/SourcesSection';
import useSourcesFileViewerStore from '../../../../stores/useSourcesFileViewerStore';

const LeftPanel = () => {
    const {leftPanelTab, setLeftPanelTab, setAiView} = useLeftPanelSync();
    const isFileViewerOpen = useSourcesFileViewerStore((state) => state.isOpen);

    const tabs = useMemo(() => [
        {
            value: 'search',
            label: 'Search',
            content: (
                <SourcesSection
                    mode="search"
                    isActive={leftPanelTab === 'search' && !isFileViewerOpen}
                />
            ),
        },
        {
            value: 'sources',
            label: 'Sources',
            content: (
                <SourcesSection
                    mode="files"
                    isActive={leftPanelTab === 'sources' && !isFileViewerOpen}
                />
            ),
        },
        {value: 'sourcePackage', label: 'Source Package', content: <SourcePackage/>},
        {value: 'aiAssistant', label: 'Tools', content: <AIAssistant isActive={leftPanelTab === 'aiAssistant'} />},
        {value: 'icr', label: 'Requirements', content: <IcrSection/>},
    ], [isFileViewerOpen, leftPanelTab]);

    const {handleTabChange} = useEditorLeftPanelTabs({
        tabs,
        leftPanelTab,
        setLeftPanelTab,
        setAiView,
    });

    return (
        <LeftPanelTabs
            tabs={tabs}
            activeTab={leftPanelTab}
            onChange={handleTabChange}
            ariaLabel="Report left panel tabs"
        />
    );
};

export default LeftPanel;
